import { useState, useEffect, useRef } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import logo from "../../settlemedlogo.png";
import ProfileIcon from "../assets/userIcon.svg";
import BurgerIcon from "../assets/menuIcon.svg";
import CrossIcon from "../assets/crossIconGreen.svg";
import LoginIcon from "@mui/icons-material/Login";
import "./drawerappbar.scss";
import InputBase from "@mui/material/InputBase";
import Badge from "@mui/material/Badge";
import SearchIcon from "@mui/icons-material/Search";
import NewReleasesOutlinedIcon from "@mui/icons-material/NewReleasesOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import NotificationPopUp from "./NotificationPopUp";
import CommentNotificationPopUp from "./CommentNotificationPopUp";
import NewCaseNotificationPopUp from "./NewCaseNotificationPopUp";
import { NotificationServices } from "../services/NotificationServices";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useLocation } from "react-router-dom";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import { useNavigate } from "react-router-dom";
import { getUser, logOut } from "../config/user";
import { useSelector } from "react-redux";
import MobileSidebar from "./MobileSidebar";
import ChangePassword from "./ChangePassword";
import SessionManagementModal from "../hospitalPersona/header/SessionManagementModal";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
let navItems = ["What we do", "Subscription", "Our Products", "Contact Us"];

function DrawerAppBar(props) {
  const [isNotificationOpen, setNotificationOpen] = useState(false);
  const [isCommentNotificationOpen, setCommentNotificationOpen] =
    useState(false);
  const [isNewCaseNotificationOpen, setNewCaseNotificationOpen] =
    useState(false);
  const [notificationCategory, setNotificationCategory] = useState("");
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isPasswordChangeOpen, setPasswordChangeOpen] = useState(false);
  const parentRef = useRef();
  const commentRef = useRef();
  const { Component, sidebar, loggedIn } = props;
  const userDetails = getUser();
  const currentRole = useSelector((state) => state.currentRole.value);
  const { notificationCount, newCaseNotificationCount, newCommentCount } =
    useSelector((store) => store.notificationReducer);
  const [anchorEl, setAnchorEl] = useState(null);
  const [osType, setOsType] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();
  const [showSessionModal, setShowSessionModal] = useState(false); // State for session modal
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlePasswordChange = (e) => {
    setPasswordChangeOpen(true);
    setAnchorEl(null);
  };

  const [mobileOpen, setMobileOpen] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
    setShowSideBar(!showSideBar);
  };

  const handlesubscription = () => {
    navigate("/dashboard/subscription");
    setAnchorEl(null);
  };

  const handleLoggedInSessions = () => {
    setShowSessionModal(true);
    setAnchorEl(null);
  };

  const OSChecker = () => {
    const userAgent = navigator.userAgent;

    let os = "Unknown OS";
    if (userAgent.includes("Win")) {
      os = "windows";
    } else if (userAgent.includes("Mac")) {
      os = "macos";
    } else if (userAgent.includes("Linux")) {
      os = "linux";
    } else if (userAgent.includes("Android")) {
      os = "android";
    } else if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
      os = "ios";
    }

    setOsType(os);
  };
  useEffect(() => {
    OSChecker();
  }, []);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        component="nav"
        className="app-bar"
        style={{ backgroundColor: "white" }}
      >
        <Toolbar className="tool-bar">
          <Box
            style={{ maxWidth: "200px", padding: "6px", marginTop: "8px" }}
            sx={{
              flexGrow: 1,
            }}
          >
            {/* Logo */}
            <img
              src={logo}
              style={{ height: "44px", marginTop: "15px" }}
              alt="Settlemed logo"
            />

            {/* Sidebar Icon - positioned below logo */}
            <IconButton
              onClick={() => setShowSideBar(!showSideBar)}
              sx={{ display: "block", mt: 1 }}
              aria-label="toggle sidebar"
              style={{ marginBottom: "6px" }}
            >
              <MenuOpenIcon />
            </IconButton>
          </Box>
          {!loggedIn && (
            <>
              <Box
                sx={{
                  display: { xs: "none", sm: "none", md: "block", lg: "block" },
                }}
              >
                {navItems.map((item) => (
                  <Button
                    key={item}
                    sx={{
                      color: "#797979",
                      fontFamily: "Inter sanaserif",
                      fontWeight: "400",
                    }}
                  >
                    {item}
                  </Button>
                ))}
              </Box>
              <Box
                style={{
                  maxWidth: "400px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* <Button className="nav-outline-button">
                  Sign up/In{" "}
                  <LoginIcon
                    style={{
                      width: "16px",
                      height: "16px",
                      padding: "0px 3px",
                    }}
                  />
                </Button> */}
                <a
                  href={
                    osType === "android" || osType === "windows"
                      ? "https://play.google.com/store/apps/details?id=com.appc"
                      : "https://apps.apple.com/us/app/settlemed/id6639615396"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "4px",
                  }}
                  className="nav-filled-button"
                >
                  <LoginIcon
                    style={{
                      transform: "rotate(90deg)",
                      width: "16px",
                      height: "16px",
                      padding: "0px 3px",
                    }}
                  />
                  DOWNLOAD APP
                </a>
              </Box>
            </>
          )}

          {loggedIn && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  marginRight: "70px",
                  width: "350px",
                  height: "36px",
                  padding: "12px 16px",
                  border: "1px solid #E4E4E4",
                }}
                className="hidden xl:flex items-center gap-2 bg-white rounded-[8px]"
              >
                <SearchIcon style={{ color: "black" }} />
                <InputBase
                  className="searchInput"
                  type="text"
                  placeholder="Search anything"
                  aria-label="search anything"
                />
              </div>

              {/* Icons */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "10px",
                }}
              >
                <div
                  style={{
                    width: "34px",
                    height: "34px",
                    borderRadius: "64px",
                    border: "1px solid #017C57",
                    marginRight: "16px",
                  }}
                  ref={parentRef}
                >
                  <IconButton
                    size="large"
                    aria-label="show 17 new notifications"
                    color="green"
                    style={{ padding: "4px" }}
                  >
                    <Badge
                      badgeContent={notificationCount || 0}
                      color="error"
                      max={999}
                      style={{ position: "relative" }}
                      onClick={() => {
                        setNotificationOpen(true);
                        setNotificationCategory("");
                      }}
                    >
                      <NotificationsNoneIcon style={{ color: "#017C57" }} />
                      {isNotificationOpen && (
                        <NotificationPopUp
                          setOpen={setNotificationOpen}
                          parentRef={parentRef}
                          notificationCategory={notificationCategory}
                        />
                      )}
                    </Badge>
                  </IconButton>
                </div>
                {newCaseNotificationCount && (
                  <div
                    className="relative mr-4 cursor-pointer"
                    onClick={() =>
                      navigate("/dashboard/manage-rpa-logs?newCase=true")
                    }
                  >
                    {" "}
                    <NewReleasesOutlinedIcon
                      style={{ fontSize: "34px" }}
                      className="text-[#017C57] "
                    />
                    <div className="absolute -top-2 -right-2 text-[11px] bg-red-600 py-1 px-2 rounded-full">
                      {newCaseNotificationCount}
                    </div>
                  </div>
                )}
                <div
                  style={{
                    width: "34px",
                    height: "34px",
                    borderRadius: "64px",
                    border: "1px solid #017C57",
                  }}
                  className="hidden xl:block"
                  ref={commentRef}
                >
                  <IconButton
                    size="large"
                    aria-label="show 17 new notifications"
                    color="green"
                    style={{ padding: "8px" }}
                  >
                    <Badge
                      badgeContent={newCommentCount || 0}
                      color="error"
                      max={999}
                      style={{ position: "relative" }}
                      onClick={() => {
                        setCommentNotificationOpen(true);
                        setNotificationCategory("Comments");
                      }}
                    >
                      <ChatBubbleOutlineRoundedIcon
                        style={{
                          color: "#017C57",
                          width: "18px",
                          height: "18px",
                        }}
                      />
                      {isCommentNotificationOpen && (
                        <CommentNotificationPopUp
                          setOpen={setCommentNotificationOpen}
                          parentRef={commentRef}
                          notificationCategory={notificationCategory}
                        />
                      )}
                    </Badge>
                  </IconButton>
                </div>
                <div className="block xl:hidden ">
                  <div
                    style={{ border: "1px solid #017C57" }}
                    className="w-[34px] h-[34px] flex items-center justify-center rounded-full ml-2"
                    onClick={() => {
                      setProfileOpen(!isProfileOpen);
                      setMenuOpen(false);
                    }}
                  >
                    <img src={ProfileIcon} alt="profile-icon" />
                  </div>
                </div>
                <div className="block xl:hidden">
                  <div
                    className="w-[34px] h-[34px] flex items-center justify-center rounded-full ml-2"
                    onClick={() => {
                      setMenuOpen(!isMenuOpen);
                      setProfileOpen(false);
                    }}
                  >
                    {isMenuOpen ? (
                      <img src={CrossIcon} alt="cross-icon" />
                    ) : (
                      <img src={BurgerIcon} alt="menu-icon" />
                    )}
                  </div>
                </div>
              </div>
              {/* Mobile Profile Menu */}
              {isProfileOpen && (
                <div className="fixed flex justify-end top-[94px] right-0 bg-[#017C5780] h-full w-full">
                  <div className="bg-white h-fit w-[90%] text-[#191919] p-2 rounded-s-[8px]">
                    <div className=" bg-[#F9F9F9] rounded-[8px] p-4">
                      <div className="flex items-center justify-between">
                        <div className="text-[#4B4B4B] text-sm font-medium ">
                          Name
                        </div>
                        <div className="text-[#4B4B4B] text-xs">
                          {userDetails?.user?.fullName}
                        </div>
                      </div>
                      <div className="flex items-center justify-between mt-4">
                        <div className="text-[#4B4B4B] text-sm font-medium ">
                          Role
                        </div>
                        <div className="text-[#4B4B4B] text-xs">
                          {userDetails?.roles[0]?.role?.roleName}
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 px-2 pb-2">
                      <div
                        className="font-medium text-sm"
                        onClick={handlesubscription}
                      >
                        Subscription
                      </div>

                      <div
                        className="font-medium text-sm mt-2"
                        onClick={() => logOut("self")}
                      >
                        Logout
                      </div>
                    </div>
                  </div>{" "}
                </div>
              )}
              {/* Mobile Sidebar */}
              {isMenuOpen && <MobileSidebar setMenuOpen={setMenuOpen} />}
              {/* Dropdown */}
              <div
                style={{
                  minWidth: "180px",
                  height: "48px",
                  borderRadius: "32px",
                  border: "1px solid #017C57",
                }}
                className="hidden xl:block"
              >
                {/* <div style={{ display: 'flex', alignItems:'center', justifyContent:'center'}}> */}
                <Button
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  style={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#017C57",
                    height: "100%",
                    width: "100%",
                    borderRadius: open ? "8px 8px 0 0" : "8px", // Square bottom corners when open
                    border: open ? "1px solid #E0E0E0" : "none",
                    borderBottom: open ? "none" : "none",
                  }}
                  startIcon={
                    <div
                      style={{
                        height: "32px",
                        width: "32px",
                        borderRadius: "32px",
                        color: "#FFF",
                        background: "#E4E4E4",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {userDetails.user.fullName
                        ? userDetails?.user?.fullName[0]
                        : ""}
                    </div>
                  }
                >
                  <div
                    style={{
                      height: "48px",
                      minWidth: "150px",
                      paddingBottom: "9px",
                    }}
                    className="flex flex-col gap-4px justify-center items-start"
                  >
                    <div style={{ height: "14px" }}>
                      {userDetails?.user?.fullName}
                    </div>
                    <div
                      style={{
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: 400,
                        textTransform: "none",
                        color: "#797979",
                        height: "12px",
                      }}
                    >
                      {currentRole?.role?.roleName}
                    </div>
                  </div>
                </Button>

                {/* </div> */}
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  PaperProps={{
                    elevation: 3,
                    sx: {
                      minWidth: anchorEl ? anchorEl.offsetWidth : "280px", // Match button width
                      borderRadius: "12px", // Rounded like a button
                      padding: "12px",
                      marginTop: "4px", // Small gap from button
                      border: "1px solid #E0E0E0",
                      "& .MuiList-root": {
                        padding: 0,
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "left", vertical: "top" }}
                  anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                  disableScrollLock={true}
                >
                  {/* <MenuItem
                    onClick={handlesubscription}
                    sx={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#191919",
                      fontFamily: "Inter",
                      "&:hover": {
                        backgroundColor: "#F5F5F5",
                        borderColor: "#017C57",
                      },
                    }}
                  >
                    Subscription
                  </MenuItem> */}

                  <MenuItem
                    onClick={handleClose}
                    sx={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#191919",
                      fontFamily: "Inter",
                      "&:hover": {
                        backgroundColor: "#F5F5F5",
                        borderColor: "#017C57",
                      },
                    }}
                  >
                    My account
                  </MenuItem>

                  <MenuItem
                    onClick={handlePasswordChange}
                    sx={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#191919",
                      fontFamily: "Inter",
                      "&:hover": {
                        backgroundColor: "#F5F5F5",
                        borderColor: "#017C57",
                      },
                    }}
                  >
                    Change Password
                  </MenuItem>

                  <MenuItem
                    onClick={handleLoggedInSessions}
                    sx={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#191919",
                      fontFamily: "Inter",
                      "&:hover": {
                        backgroundColor: "#F5F5F5",
                        borderColor: "#017C57",
                      },
                    }}
                  >
                    LoggedIn Sessions
                  </MenuItem>

                  <MenuItem
                    onClick={() => logOut()}
                    sx={{
                      border: "1px solid #E0E0E0",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#191919",
                      fontFamily: "Inter",
                      "&:hover": {
                        backgroundColor: "#F5F5F5",
                        borderColor: "#017C57",
                      },
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>

                {isPasswordChangeOpen && (
                  <ChangePassword setOpen={setPasswordChangeOpen} />
                )}

                {showSessionModal && (
                  <SessionManagementModal
                    visible={showSessionModal}
                    onClose={() => setShowSessionModal(false)}
                  />
                )}
              </div>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <nav>
        <div
          // style={
          //   !showSideBar ? { width: 0 } : { height: "95%", marginTop: "94px" }
          // }
          className={`hidden xl:block sticky top-[94px] transition-all duration-300 ease-in-out mt-[94px] ${
            showSideBar ? "w-fit" : "w-0"
          }`}
        >
          {sidebar}
        </div>
      </nav>
      {Component}
    </Box>
  );
}
export default DrawerAppBar;
